import * as actionTypes from 'constants/ActionTypes';
import formErrorsTracker from 'metrics/user-analytics/formErrorsTracker';
import { exchangeAttemptTracker } from 'metrics/user-analytics/purchase';

const middleware = (store) => (next) => (action) => {
  const result = next(action);

  switch (action.type) {
    case actionTypes.UA_FORM_ERRORS: {
      const { funnelStep, fields } = action;

      formErrorsTracker(funnelStep, fields);
      break;
    }

    case actionTypes.RECEIVE_PURCHASE: {
      const { purchase } = store.getState();

      if (purchase.get('isExchange')) {
        exchangeAttemptTracker(purchase.toJS());
      }
      break;
    }

    default:
      break;
  }

  return result;
};

export default middleware;
